import { useRouter as useNextRouter, usePathname, useSearchParams } from 'next/navigation';

import type { XRouter } from './types';

function useNullableSearchParams(): ReturnType<typeof useSearchParams> | null | undefined {
  return useSearchParams();
}

export function useRouter(): XRouter {
  const nextRouter = useNextRouter();
  const pathname = usePathname();
  const searchParams = useNullableSearchParams();

  const search = searchParams?.toString() ?? '';
  const asPath = pathname + (search ? `?${search}` : '');

  const query: Record<string, string | string[] | undefined> = {};
  if (searchParams !== null && searchParams !== undefined) {
    for (const [key, value] of searchParams.entries()) {
      const existing = query[key];
      if (existing) {
        if (Array.isArray(existing)) {
          existing.push(value);
        } else {
          query[key] = [existing, value];
        }
      } else {
        query[key] = value;
      }
    }
  }

  return {
    ...nextRouter,
    basePath: '',
    isReady: true,
    pathname,
    query,
    webOnlyAsPath: asPath,
    webOnlyReloadPage: () => {
      // In newer Next.js versions, we can use window.location.reload() instead of router.reload()
      if (typeof window !== 'undefined') {
        window.location.reload();
      }
      return undefined;
    },
  };
}
